// extracted by mini-css-extract-plugin
export default {"calendarPicker":"CalendarIcon_calendarPicker__tRsqY"};